import { render, staticRenderFns } from "./cancellation-agreement.vue?vue&type=template&id=19b4f39a&scoped=true"
import script from "./cancellation-agreement.vue?vue&type=script&lang=js"
export * from "./cancellation-agreement.vue?vue&type=script&lang=js"
import style0 from "./cancellation-agreement.vue?vue&type=style&index=0&id=19b4f39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_bf339e0f7cd061f35bf078d2faee2298/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b4f39a",
  null
  
)

export default component.exports